// tv-collection-custom.js - Script to customize TV Collection page
document.addEventListener('DOMContentLoaded', function() {
  // Check if current page is TV Collection
  if (window.location.pathname.includes('/collections/tv-collection')) {
    // Hide the category sidebar block
    hideElementsOnTvCollection();
  }
});

/**
 * Hides specific elements on the TV Collection page
 */
function hideElementsOnTvCollection() {
  // Target the category sidebar block
  const categorySidebar = document.querySelector('#CollectionFiltersForm > div.collection-filters__item.facets__wrapper > div.sidebarBlock.js-filter.sidebarBlock-collapse.หมวดหมู่สินค้า');
  
  if (categorySidebar) {
    categorySidebar.style.display = 'none';
  }
}
